export const formatHexStr = (
  value,
  left = 10,
  right = 8,
  length = 21,
  removeDotted = false,
) => {
  if (value.length > length) {
    return removeDotted
      ? `${value.slice(0, left)}${right > 0 ? value.slice(-right) : ""}`
      : `${value.slice(0, left)}${
          right > 0 ? `...${value.slice(-right)}` : "..."
        }`;
  }
  return value;
};
